import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { Section } from './types';

interface BlueprintNavProps {
  sections: Section[];
}

const BlueprintNav = ({ sections }: BlueprintNavProps) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.Hero,
  });

  return (
    <nav className="flex flex-wrap gap-8">
      {sections.map((section) => {
        const anchorId = section.anchorId || section.sectionType;
        return (
          <a
            key={section.id}
            href={`#${anchorId}`}
            onClickCapture={() =>
              trackEvent(click({ clickTarget: ClickTarget.NavLink, clickText: section.title }))
            }
            className="inline-flex items-center rounded-full border border-solid border-grayscale-gray bg-white px-16 py-6 font-suisse-intl text-button-sm text-grayscale-charcoal no-underline transition-colors hover:bg-[#3979f3] hover:text-white"
          >
            {section.title}
          </a>
        );
      })}
    </nav>
  );
};

export default BlueprintNav;
